export const ENDPOINT =
  process.env.REACT_APP_ENDPOINT || "http://localhost:8085";

export const ADMIN_USERS = [
  "paul.abarnou@spendesk.com",
  "antoine.blanctel-chevrel@spendesk.com",
  "paul.nardone@spendesk.com",
  "valentin.rabinovich@spendesk.com",
  "cedric.urvoy@spendesk.com",
  "camille.imbert@spendesk.com",
  "clarisse@spendesk.com",
  "sergi.blanquera-martin@spendesk.com",
  "agustin.chiavassa@spendesk.com",
  "ryan.franklin-martinez@spendesk.com",
  "matthew.mctighe@spendesk.com",
  "kosovare.lenjani@spendesk.com",
  "melissa.hughes@spendesk.com",
  "geoffroy.pommier@spendesk.com",
  "sebastien.allibe@spendesk.com",
  "louisa.browne@spendesk.com",
  "jonathan.fedida-ext@spendesk.com",
];

export const isAdmin = (email) => {
  return ADMIN_USERS.includes(email?.toLowerCase());
};
